import { useParams } from 'react-router-dom';

// This approach, discovered in one of react-router-v6 issues (https://github.com/remix-run/react-router/issues/8200#issuecomment-1113653311)
// allows to ensure type safety when destructuring route params inside components.

// ex.: const { id } = useRouteParams('/:id');

// react-router's own `useParams` hook can't derive parameter names from the path
// provided, and requires additional explicit parametrization, i.e.:
// const { id } = useParams<{ id: string }>();

// But it won't throw an error if someone renames path from `:id` to `:notId`.
export const useRouteParams = <RoutePath extends string>(_path: RoutePath) => {
  const params = useParams<PathParamsLiteral<RoutePath>>();
  return params as NonNullableKeys<typeof params>;
};

// Transforms the path to params names as a string literal
type PathParamsLiteral<S extends string> = S extends
  | `:${infer T}/${infer U}`
  | `/:${infer T}/${infer U}`
  ? T | PathParamsLiteral<U>
  : S extends `${infer _T}/${infer U}`
    ? PathParamsLiteral<U>
    : S extends `:${infer T}` | `/:${infer T}`
      ? T
      : never;

type NonNullableKeys<T> = {
  [P in keyof T]-?: NonNullable<T[P]>;
};

export function isLocalUrl(url: string): boolean {
  return url.includes('127.0.0.1') || url.includes('localhost');
}

export { optionalRouteParam } from './optional-route-param';
export { useNavigateRoute } from './use-navigate-route';
